import { LocationMapAddressFields } from "../../components/features/location/LocationMapAddressFields";
import type { LocationEditFormGridProps } from "./LocationEditFormGrid.types";

export type { LocationFormValues, LocationEditFormGridProps } from "./LocationEditFormGrid.types";

const LocationEditFormGrid = (props: LocationEditFormGridProps) => (
    <LocationMapAddressFields
        {...props}
        showNameField
        showLocationEnabledField
    />
);

export { LocationEditFormGrid };
